var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('columns',[_c('column',{staticClass:"is-12"},[_c('u-header',{attrs:{"title":_vm.$t('_.billing_settings')}}),_vm._v(" "),_c('client-invoice-consolidation-comp',{attrs:{"tag":"u-contextualise","client":_vm.$clientProvider().client,"is-sticky":true,"brand-name":_vm.$_.get(
          _vm.$clientData,
          'account.brand.name',
          _vm.$t('_.brand')
            .toString()
            .toLocaleLowerCase()
        )},on:{"refreshClient":function($event){return _vm.$clientMethods.reloadData()}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }